<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.506 17.507">
    <g transform="translate(.756 .75)" stroke="currentColor" stroke-width="1.5">
      <circle cx="8" cy="8" r="8" fill="currentColor"/>
      <path d="M8 0a8 8 0 1 0 8 8H8Z" fill="#fff"/>
    </g>
  </svg>
</template>
